import Utils from '../../shared/utils';

export const DateHelper = {
  oneDayTime: 1000 * 60 * 60 * 24,
  nowUTC: (): Date => Utils.toUtcDate(new Date()),
  addYears: (date: Date, n: number): Date => {
    const inputDate = Utils.toUtcDate(date);
    return new Date(inputDate.setFullYear(inputDate.getFullYear() + n));
  },
  addMonths: (date: Date, n: number): Date => {
    const inputDate = Utils.toUtcDate(date);
    return new Date(inputDate.setMonth(inputDate.getMonth() + n));
  },

  addDays: (date: Date, n: number): Date => {
    const inputDate = Utils.toUtcDate(date);
    return new Date(inputDate.setDate(inputDate.getDate() + n));
  },

  fromString: (s: string): Date => Utils.toUtcDate(new Date(s)),

  getDaysBetween(date1: Date, date2: Date): number {
    return Math.floor(
      Math.abs(Utils.toUtcDate(date2).getTime() - Utils.toUtcDate(date1).getTime()) /
        this.oneDayTime,
    );
  },

  minDate: () => new Date('1/1/0001 12:00:00 AM'),
};
